import { computed, inject } from '@angular/core';
import { MgsWebApi } from '../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';
import { IKidsBuchungAppAvailable } from '@mng/mgs-lib';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { dateToIsoDateString } from '@mng/mng-ts-helpers';

export const KidsAppAvailableStore = signalStore(
  { providedIn: 'root' },
  withState<IKidsBuchungAppAvailable>({
    appAvailable: '2023-09-30',
    appAvailableFrom: '2023-03-05',
    appAvailableMessage: undefined,
    reservierungMail: 'reservierung@merkur-lifestyle.at'
  }),
  withMethods((state) => {
    const webApi = inject(MgsWebApi);
    return {
      initialize: async () => {
        const result = await firstValueFrom(webApi.kidsBuchungAppAvailable());
        patchState(state, result.data);
      }
    };
  }),
  withComputed((state) => {
    const appAvailableFromDate = computed(() =>
      state?.appAvailableFrom() ? new Date(state.appAvailableFrom()) : undefined
    );
    const appAvailableUntilDate = computed(() => (state?.appAvailable() ? new Date(state.appAvailable()) : undefined));

    return {
      appAvailableFromDate,
      appAvailableUntilDate,
      isAppAvailable: computed(() => {
        // Date Instanz "gleich" wie "appAvailableFromDate" erzeugen -> damit der Vergleich funktioniert
        const currentDay = new Date(dateToIsoDateString());
        return !(
          currentDay.getTime() < appAvailableFromDate().getTime() ||
          currentDay.getTime() > appAvailableUntilDate().getTime()
        );
      }),
      appNotAvailableMessage: computed(() =>
        state.appAvailableMessage()?.length > 0
          ? state.appAvailableMessage()
          : createAppAvailableMessage(state.appAvailableFrom())
      )
    };
  })
);

function createAppAvailableMessage(appAvailableFrom: string): string {
  const availableFromDate = new Date(appAvailableFrom);

  return `Reservierungen für das Jahr ${availableFromDate.getFullYear()} werden ab ${availableFromDate.getDate()}.${
    availableFromDate.getMonth() + 1
  }.${availableFromDate.getFullYear()} entgegengenommen.`;
}

export type KidsAppAvailableStore = InstanceType<typeof KidsAppAvailableStore>;
